import styled from "styled-components";

const PricingWrapper = styled.section`
  .swiper-slide {
    min-height: 600px;
  }
  .swiper-pagination-bullet {
    width: 44px;
    height: 8px;
    border-radius: 10px;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s ease;
  }

  .swiper-pagination-bullet-active {
    background: var(--themeColor);
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      width: 26px;
      height: 26px;
      [stroke] {
        stroke: var(--themeColor);
      }
    }
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "";
  }

  .swiper-button-prev {
    left: -40px; /* Adjust based on design */
  }

  .swiper-button-next {
    right: -40px; /* Adjust based on design */
  }

  body.rtl & {
    .swiper-button-prev {
      transform: scaleX(-1);
      right: -40px;
      left: unset;
    }

    .swiper-button-next {
      transform: scaleX(-1);
      left: -40px;
      right: unset;
    }
  }
`;

const PricingCardWrapper = styled.div`
  min-height: 520px;
  height: 100%;
  box-shadow: 0px 19.2px 27.6px -9px #064a931a;
  border: 1px solid ${({ border }) => (border ? border : "#eaedf3")};
  border-radius: 9px;
  svg {
    [stroke] {
      stroke: ${({ color }) =>
        color ? color : "var(--themeColor2)"}!important;
    }
  }
`;

export { PricingWrapper, PricingCardWrapper };
